"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  expiryDays: 0,
  openFuturePeriods: 0,
  timelyDays: 15,
  periodType: 'Monthly'
};
exports.default = _default;
//# sourceMappingURL=dataSet.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2/model/config/model-defaults/dataSet.js
// module id = 1234
// module chunks = 0